const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Orbitron:wght@400;600;700;900&display=swap');

  .lead-section {
    position: relative;
    z-index: 1;
    min-height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 4rem 80px;
    font-family: 'Rajdhani', sans-serif;
  }

  .lead-container {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
  }

  .lead-header {
    text-align: center;
    margin-bottom: 4rem;
  }

  .lead-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    font-weight: 600;
    color: #ff8c00;
    letter-spacing: 5px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 1rem;
    opacity: 0;
    animation: leadFadeUp 0.7s ease 0.1s both;
  }
  .lead-label::before, .lead-label::after { content: ''; width: 50px; height: 1px; }
  .lead-label::before { background: linear-gradient(to right, transparent, #ff8c00); }
  .lead-label::after  { background: linear-gradient(to left,  transparent, #ff8c00); }

  .lead-title {
    font-family: 'Orbitron', monospace;
    font-size: clamp(1.8rem, 4vw, 2.8rem);
    font-weight: 900;
    background: linear-gradient(135deg, #ffffff 0%, #38c8ff 60%, #00aaff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 0 20px rgba(0,170,255,0.3));
    opacity: 0;
    animation: leadFadeUp 0.7s ease 0.2s both;
  }

  .lead-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    opacity: 0;
    animation: leadFadeUp 0.7s ease 0.3s both;
  }

  .lead-card {
    background: rgba(0, 20, 50, 0.5);
    border: 1px solid rgba(0,170,255,0.12);
    border-top: 2px solid #00aaff;
    padding: 1.8rem;
    position: relative;
    transition: all 0.3s;
  }

  .lead-card:hover {
    border-color: rgba(0,170,255,0.3);
    box-shadow: 0 0 22px rgba(0,170,255,0.08);
    transform: translateY(-3px);
  }

  .lead-card::before {
    content: '';
    position: absolute;
    top: -2px; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(to right, #00aaff, transparent);
  }

  .lead-card-top {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .lead-icon-wrap {
    width: 44px;
    height: 44px;
    background: rgba(0,170,255,0.08);
    border: 1px solid rgba(0,170,255,0.25);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    flex-shrink: 0;
  }

  .lead-info {}

  .lead-position {
    font-family: 'Orbitron', monospace;
    font-size: 0.78rem;
    font-weight: 700;
    color: #e8f4ff;
    margin-bottom: 0.25rem;
    line-height: 1.3;
  }

  .lead-org {
    font-size: 0.88rem;
    color: #00aaff;
    font-weight: 600;
  }

  .lead-year {
    font-family: 'Orbitron', monospace;
    font-size: 0.6rem;
    color: #4a7a9b;
    letter-spacing: 1px;
    margin-top: 0.2rem;
  }

  .lead-divider {
    height: 1px;
    background: linear-gradient(to right, rgba(0,170,255,0.2), transparent);
    margin: 0.8rem 0;
  }

  .lead-desc {
    font-size: 0.88rem;
    line-height: 1.7;
    color: rgba(232,244,255,0.5);
  }

  .lead-role-badge {
    display: inline-block;
    background: rgba(0,170,255,0.07);
    border: 1px solid rgba(0,170,255,0.2);
    border-radius: 3px;
    padding: 0.15rem 0.6rem;
    font-family: 'Orbitron', monospace;
    font-size: 0.55rem;
    color: #00aaff;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-top: 0.8rem;
    display: block;
    width: fit-content;
  }

  @keyframes leadFadeUp {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @media (max-width: 900px) {
    .lead-section { padding: 100px 2rem 60px; }
    .lead-grid { grid-template-columns: 1fr; }
  }
`;

const LEADERSHIP = [
  {
    icon: "👥",
    position: "Technical Team Leader",
    org: "GE-ETHICS Film Making",
    year: "2025",
    desc: "Led a team in handeling the whole technicalities in the film.",
    badge: "Leader",
  },
  {
    icon: "🤝",
    position: "Head / Team Captain Basketball Mens",
    org: "FAITH Colleges – BS Computer Engineering",
    year: "2023 – Present",
    desc: "Active head and well handled teammates through years of competing.",
    badge: "Team Captain",
  },
];

export default function Leadership() {
  return (
    <section className="lead-section" id="leadership">
      <style>{styles}</style>
      <div className="lead-container">

        <div className="lead-header">
          <p className="lead-label">Roles & Involvement</p>
          <h2 className="lead-title">Leadership / Organizations</h2>
        </div>

        <div className="lead-grid">
          {LEADERSHIP.map((l, i) => (
            <div className="lead-card" key={i}>
              <div className="lead-card-top">
                <div className="lead-icon-wrap">{l.icon}</div>
                <div className="lead-info">
                  <p className="lead-position">{l.position}</p>
                  <p className="lead-org">{l.org}</p>
                  <p className="lead-year">{l.year}</p>
                </div>
              </div>
              <div className="lead-divider" />
              <p className="lead-desc">{l.desc}</p>
              <span className="lead-role-badge">{l.badge}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}